import { CryptoCore } from './core/crypto-core';
import { EncryptionType } from './core/crypto-core/types';

export const makeKeyPair = async (mnemonic: string, encryptionType: EncryptionType) => {
  const cryptoCore = new CryptoCore(encryptionType);

  try {
    return await cryptoCore.mnemonicToKeyPair(mnemonic);
  } catch (er) {
    return null;
  }
};
